import { JSX } from 'react'

import { IconProps } from '../../icon'

const FavoriteOn: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M39.5042 15.7774V15.7446C38.2897 12.3142 35.0235 10 31.3798 10C28.2284 10 25.5039 11.7234 23.9939 14.251C22.4838 11.7234 19.7593 10 16.608 10C12.9642 10 9.69804 12.3142 8.48347 15.7446V15.7774C4.87259 26.6921 22.648 36.5236 23.403 36.9339C23.5835 37.0324 23.7969 37.0816 23.9939 37.0816C24.1908 37.0816 24.3878 37.0324 24.5847 36.9339C25.3397 36.5236 43.1151 26.6921 39.5207 15.7774H39.5042Z'
      fill='#E53935'
    />
  </svg>
)

export default FavoriteOn
